/**
 * The "plotly-like" hover card every chart template shows for the element nearest the pointer.
 * Positioned at an arbitrary pixel offset supplied by the caller — the one place in this
 * feature where an inline `style` is the right tool, since Tailwind has no utility for a
 * mouse-tracked coordinate. Purely presentational and `pointer-events-none`, so it can never
 * itself swallow the hover/click/drag gesture that produced it.
 */
import type { ReactNode } from "react";

interface ChartTooltipProps {
  /** Position relative to the nearest positioned ancestor (the chart's own wrapper) — a pixel
   *  number, or a percentage string for charts positioned in their own viewBox-relative space
   *  (a plain percentage tracks a `preserveAspectRatio="none"` SVG's stretch with no DOM
   *  measurement needed). */
  x: number | string;
  y: number | string;
  children: ReactNode;
}

export function ChartTooltip({ x, y, children }: ChartTooltipProps) {
  return (
    <div
      role="tooltip"
      className="bg-foreground text-background pointer-events-none absolute z-20 max-w-56 rounded-md px-2 py-1.5 text-[11px] leading-snug shadow-lg"
      style={{ left: x, top: y, transform: "translate(-50%, calc(-100% - 8px))" }}
    >
      {children}
    </div>
  );
}
